<template>
  <div id="vue-app">
    <b-card>
      <b-row>
        <b-col sm="5">
          <h4 class="card-title mb-0">Frequently Bought Together JS</h4>
          <div class="small text-muted">Shopify application</div>
        </b-col>
        <b-col sm="7" class="d-md-block">
          <span class="float-right">
            <b-dropdown
              id="ddown-right"
              right
              :text="currentStore.storeUrl"
              variant="primary"
              class="m-2 app-dropdown"
            >
              <b-dropdown-item
                v-for="store in stores"
                :key="store.shopifyStoreId"
                href="#"
                @click="changeStore(store.shopifyStoreId)"
              >{{ store.storeUrl}}</b-dropdown-item>
            </b-dropdown>
            <br>
            <span class="small text-muted float-right store-label">Your Shopify store</span>
          </span>
        </b-col>
      </b-row>
      <br>
      <container
        v-for="cont in containers"
        :key="cont.shopifyStoreId"
        :storeId="cont.shopifyStoreId"
        :title="currentStore.storeUrl"
      >{{ cont.shopifyStoreId }}</container>
    </b-card>
  </div>
</template>

<script>

import container from "./AppContainer"

export default {
  name: "vueapp",
  created() {
    this.$store.dispatch('shopifyStores/getShopifyStores')
  },
  components: {
    container
  },
  data: () => {
    return {
      currentStore: { storeUrl: "You have no stores" },
      containers: []
    };
  },
  computed: {
    stores() {
      return this.$store.state.shopifyStores.stores;
    }
  },
  watch: {
    stores(newStores, oldStores) {
      if (Array.isArray(newStores) && newStores.length) {
        this.changeStore(newStores[0].shopifyStoreId);
      }
    }
  },
  mounted: function () {
  },
  methods: {
    changeStore(shopifyStoreId) {
      this.currentStore = this.stores.find(s => s.shopifyStoreId == shopifyStoreId);
      this.containers = [this.currentStore];
    }
  }
};
</script>
<style lang="scss">
.card-header {
  text-transform: uppercase;
  font-weight: 600;
  color: #555;
}
.store-label {
  margin-right: 10px;
}
.k-button {
  font-size: 15px;
}
.app-dropdown {
  margin: 0 !important;
}
</style>
